<template>
  <div>
    logout...
  </div>
</template>

<script>
  import store from '@/store'

  export default {
    name: 'logout',

    mounted () {
      for (let o in localStorage) {
        localStorage.removeItem(o)
      };

      store.commit('LOGOUT_USER');
      this.$router.push('login');

    }
  }
</script>



// WEBPACK FOOTER //
// src/components/app/auth/Logout.vue